
  class RenderSection extends HTMLElement {
    connectedCallback() {
      const targetSelector = this.getAttribute('target');
      if (!targetSelector) return;

      // Find all elements matching the selector
      const targets = document.querySelectorAll(targetSelector);
      if (targets.length === 0) {
        console.warn(`render-section: No elements found for selector "${targetSelector}"`);
        return;
      }

      // Move each matched target node into this <render-section>
      targets.forEach(target => {
        // Prevent moving this <render-section> into itself (in case selector is too broad)
        if (this.contains(target) || target === this) return;

        // Append the actual element (this will *move* it in the DOM)
        this.appendChild(target);
      });

      // Optionally: if you want the <render-section> to remain as placeholder, omit this.remove()
      // Remove the <render-section> wrapper if you prefer the moved content to stay where the tag was
      // this.remove();
    }
  }

  customElements.define('render-section', RenderSection);

